import { useEffect, useState } from 'react';
import { Outlet, useSearchParams, useNavigate } from 'react-router-dom';
import { Loader } from '@/components/Loader';
import { useBrandingColors } from '@/hooks/useBrandingColors';
import { useCustomFavicon } from '@/hooks/useCustomFavicon';
import { useWhitelabelStore } from '@/stores/whitelabel';
import { LoginContainer } from '@/components/LoginContainer';
import { useKioskStore } from '@/stores/kiosk';
import { EKioskRouterNames } from '@/types';
import { LOCAL_STORAGE_KEYS } from '@/utils/constants';

export const ActivationLoginLayout = () => {
  const navigate = useNavigate();

  const {
    setCurrentWhitelabelById,
    setCurrentWhitelabelBySubdomain,
    getInstitutionsWhitelabel,
    currentWhitelabel,
  } = useWhitelabelStore((state) => ({
    setCurrentWhitelabelById: state.setCurrentWhitelabelById,
    setCurrentWhitelabelBySubdomain: state.setCurrentWhitelabelBySubdomain,
    getInstitutionsWhitelabel: state.getInstitutionsWhitelabel,
    currentWhitelabel: state.currentWhitelabel,
  }));

  const getKioskInstitution = useKioskStore(
    (state) => state.getKioskInstitution,
  );

  const [loading, setLoading] = useState(true);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const callback = async () => {
      const kioskTokenStorage = localStorage.getItem(
        LOCAL_STORAGE_KEYS.KIOSK_TOKEN,
      );
      const kioskIdStorage = localStorage.getItem(LOCAL_STORAGE_KEYS.KIOSK_ID);
      const isAuthStorage = !!kioskTokenStorage && !!kioskIdStorage;

      const kioskTokenLocation = window.location.hash.substring(1);
      const kioskIdLocation = searchParams.get('kioskId');
      const isAuthLocation = !!kioskTokenLocation && !!kioskIdLocation;

      try {
        await getInstitutionsWhitelabel();
        const currentSubdomain = window.location.host.split('.')[0];
        if (!isAuthStorage && !isAuthLocation) {
          setCurrentWhitelabelBySubdomain(currentSubdomain);
          return;
        }
        if (isAuthLocation) {
          localStorage.setItem(LOCAL_STORAGE_KEYS.KIOSK_ID, kioskIdLocation);
          localStorage.setItem(
            LOCAL_STORAGE_KEYS.KIOSK_TOKEN,
            kioskTokenLocation,
          );
        }
        const kioskInstitution = await getKioskInstitution();
        if (kioskInstitution) {
          setCurrentWhitelabelById(kioskInstitution.id);
          navigate(EKioskRouterNames.KIOSK);
          return;
        }
        localStorage.removeItem(LOCAL_STORAGE_KEYS.KIOSK_ID);
        localStorage.removeItem(LOCAL_STORAGE_KEYS.KIOSK_TOKEN);
        setCurrentWhitelabelBySubdomain(currentSubdomain);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    void callback();
  }, [
    getInstitutionsWhitelabel,
    getKioskInstitution,
    navigate,
    searchParams,
    setCurrentWhitelabelById,
    setCurrentWhitelabelBySubdomain,
  ]);

  useBrandingColors(
    currentWhitelabel?.whitelabel?.enabled
      ? currentWhitelabel?.whitelabel?.primaryColor
      : undefined,
    currentWhitelabel?.whitelabel?.enabled
      ? currentWhitelabel?.whitelabel?.buttonTextColor
      : undefined,
  );
  useCustomFavicon(
    currentWhitelabel?.whitelabel?.enabled &&
      currentWhitelabel?.whitelabel?.faviconImageUrl
      ? currentWhitelabel.whitelabel.faviconImageUrl
      : undefined,
  );

  return loading ? (
    <div style={{ height: '100dvh' }}>
      <Loader />
    </div>
  ) : (
    <LoginContainer
      as="main"
      background={
        (currentWhitelabel?.whitelabel?.enabled &&
          currentWhitelabel?.whitelabel?.coverImageUrl) ||
        undefined
      }
    >
      <Outlet />
    </LoginContainer>
  );
};
